import { FC } from 'react';

import { CheckableCard, Text, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';
import { GearOutlinedSize24, KeyOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import { setWizardCpcMode, WizardCpcMode } from 'store/models/campaignCreationWizard';
import { useDispatch } from 'store/utils';

interface SettingsModeCardProps {
    mode: WizardCpcMode;
    title: string;
    description: string;
    checked: boolean;
}

export const SettingsModeCard: FC<SettingsModeCardProps> = ({ mode, title, description, checked }) => {
    const dispatch = useDispatch();

    return (
        <CheckableCard
            padding={24}
            borderRadius={24}
            type="radio"
            value={mode}
            name="settings-mode"
            checked={checked}
            onChange={() => dispatch(setWizardCpcMode(mode))}
            data-qa={`settings-mode-card-${mode}`}
            flexible
            toneHover
        >
            <VSpacingContainer default={8}>
                {mode === WizardCpcMode.Quick ? <KeyOutlinedSize24 /> : <GearOutlinedSize24 />}
                <VSpacing default={0} />
                <Text typography="subtitle-1-semibold">{title}</Text>
                <Text typography="label-3-regular" style="secondary">
                    {description}
                </Text>
            </VSpacingContainer>
        </CheckableCard>
    );
};
